module.exports = __webpack_public_path__ + "1705cbfa15c393f75093773c35806236.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/hassle-free.png
// module id = 1310
// module chunks = 47